import $ from 'jquery';

let loaded = false;

export default function load(cb) {
  if ($('#yt-api-script').length) {
    if (loaded) {
      cb();
    } else {
      $(document).on('yt-ready', event => cb());
    }

    return;
  }

  window.onYouTubeIframeAPIReady = function() {
    loaded = true;
    $(document).trigger('yt-ready');
    cb();
  };

  const tag = document.createElement('script');
  tag.id = 'yt-api-script';
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};
